// extracted by mini-css-extract-plugin
module.exports = {"component":"container_component__sGeLN"};